import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import SAR from "@componentsShared/SAR/SAR";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import PostInfoModal from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/PostInfo/PostInfoModal";
import PostInfoDesktop from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/PostInfo/PostInfoDesktop";
import { Drawer } from "vaul";
import DrawerPaymentInfo from "@/pages/checkout/components/PaymentInfo/DrawerPaymentInfoV1";
import stl from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/InfoDetailsComponent/InfoDetailsComponent.module.css";
var InfoDetailsComponentNew = function InfoDetailsComponentNew(_ref) {
  var _details$steps, _details$referral_dis, _allOfferedDoc$docume;
  var details = _ref.details,
    allOfferedDoc = _ref.allOfferedDoc,
    isFinance = _ref.isFinance,
    headerMessage = _ref.headerMessage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var isCancelled = details === null || details === void 0 ? void 0 : (_details$steps = details.steps) === null || _details$steps === void 0 ? void 0 : _details$steps.some(function (item) {
    return item.completed == -1;
  });
  var isMobile = useIsMobile();
  var desktopInfo = useBoolean();
  var mobileInfo = useBoolean();
  var _useHelpers2 = useHelpers(),
    navigateTo = _useHelpers2.navigateTo;
  var handleInfoDetailsClick = function handleInfoDetailsClick() {
    if (isMobile) {
      mobileInfo.setTrue();
    } else {
      desktopInfo.setTrue();
    }
  };

  // Map the tracking OrderDetails fields to what DrawerPaymentInfo expects
  var checkoutOrderData = _objectSpread(_objectSpread({}, details), {}, {
    post_is_new: 0,
    referral_code: (_details$referral_dis = details.referral_discount) !== null && _details$referral_dis !== void 0 ? _details$referral_dis : ""
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, headerMessage.descriptionMessage && headerMessage.titleMessage && /*#__PURE__*/React.createElement("div", {
    className: [stl.headerNote, "m-show"].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null), headerMessage.titleMessage), /*#__PURE__*/React.createElement("p", null, headerMessage.descriptionMessage)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-start justify-start text-[#6B7EA5] text-base font-normal leading-6"
  }, t("أهلاً", {
    ns: "web_tracking_finance"
  }), " ", details === null || details === void 0 ? void 0 : details.customer_name), /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-gray-gainsboro rounded py-3 px-2 flex flex-col gap-2 md:border-none md:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 w-full justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-8 h-8 border border-solid border-gray-gainsboro rounded-full"
  }, /*#__PURE__*/React.createElement("img", {
    src: details === null || details === void 0 ? void 0 : details.make_logo,
    className: "w-5 h-3 object-contain"
  })), /*#__PURE__*/React.createElement(Link, {
    className: "text-start text-primary-new font-bold text-xs leading-6 underLine",
    to: createUrl("/car-info/".concat(details === null || details === void 0 ? void 0 : details.post_id, "?isCancelled=").concat(isCancelled, "&backToTracking=true"))
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underline"
  }, details === null || details === void 0 ? void 0 : details.post_title))), !isFinance && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 cursor-pointer",
    onClick: handleInfoDetailsClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-base text-primary-new font-bold"
  }, details === null || details === void 0 ? void 0 : details.total_price), /*#__PURE__*/React.createElement(SAR, {
    className: "text-primary-new"
  })), isMobile ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-drop-down-rounded",
    className: "text-primary-new",
    width: 6,
    height: 6
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: "mingcute--information-line",
    className: "text-primary-new",
    width: 4,
    height: 4
  })))), /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-5 text-[#6B7EA5]"
  }, tShort("tracking/post_id", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary text-sm font-bold leading-5"
  }, details === null || details === void 0 ? void 0 : details.id)), (allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : (_allOfferedDoc$docume = allOfferedDoc.documents) === null || _allOfferedDoc$docume === void 0 ? void 0 : _allOfferedDoc$docume.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1",
    onClick: function onClick() {
      navigateTo("".concat(isFinance ? "/tracking-finance-details/view-all-offered-doc/".concat(details === null || details === void 0 ? void 0 : details.id) : "/tracking-checkout-details/view-all-offered-doc/".concat(details === null || details === void 0 ? void 0 : details.id)));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "mingcute--news-line",
    width: 5,
    height: 5,
    className: "text-primary-new"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-bold leading-5 text-primary-new"
  }, tShort("tracking/order_paper", {
    ns: "web_tracking"
  })))))), /*#__PURE__*/React.createElement(PostInfoModal, {
    show: desktopInfo.value,
    onClose: desktopInfo.setFalse
  }, /*#__PURE__*/React.createElement(PostInfoDesktop, {
    onClose: desktopInfo.setFalse,
    details: details
  })), /*#__PURE__*/React.createElement(Drawer.Root, {
    open: mobileInfo.value,
    onOpenChange: function onOpenChange(o) {
      if (!o) mobileInfo.setFalse();
    },
    snapPoints: [1],
    closeThreshold: 0.65
  }, /*#__PURE__*/React.createElement(Drawer.Portal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425]/50 opacity-50 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "fixed bottom-0 left-0 right-0 z-[9999] bg-[#fbfbfb] rounded-t-[20px] flex flex-col outline-none max-h-[95vh]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center pt-3 pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[49px] h-[5px] rounded-full bg-[#020202]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: mobileInfo.setFalse,
    className: "w-7 h-7 flex items-center justify-center text-[#09090B] hover:opacity-70 cursor-pointer transition-opacity"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close",
    width: 4,
    height: 4
  })))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1"
  }, /*#__PURE__*/React.createElement(DrawerPaymentInfo, {
    checkoutOrder: checkoutOrderData,
    hideData: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center pb-3 pt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#020202] h-[4.5px] w-[127px] rounded-full"
  }))))));
};
export default InfoDetailsComponentNew;